document.addEventListener("alpine:init", () => {
  const appScope = STUDYFLEX_DATA.scope;
  const storePrefix = appScope ? appScope + "_" : "";
  const storeName = `${storePrefix}studyFlex`;

  Alpine.data("studyFlexResultTable", () => ({
    storeName: storeName,

    numResultDisplayed: 10,
    stepResultDisplayed: 10,
    hideAll: true,

    filteredAcademicItems: [],

    selectedStudyFlexOption: "",

    numCols: 3,

    _getStore() {
      return this.$store[this.storeName];
    },

    init() {
      this.$watch(`$store.${storeName}.filteredAcademicItems`, (newVal) => {
        // get latest selected StudyFlex option value
        this.selectedStudyFlexOption =
          this._getStore().firstLevelFilters.studyFlexOptions.slice(0);

        this.filteredAcademicItems = newVal;

        // this.numCols =
        //   this._getStore().firstLevelFilters.studyLevels[0] === "UG" ? 3 : 2;

        this.numResultDisplayed = 10;
        this.hideAll = true;
        this.$nextTick(() => {
          this.hideAll = false;
        });
      });
    },
  }));
});
